import React from 'react';
import { useIntl, FormattedMessage } from '@kyruus/intl';
import _get from 'lodash/get';
import _reduce from 'lodash/reduce';

export const IntlOption = ({
  messageDescriptor,
  messageDescriptorValues,
  ...props
}) => {
  const intl = useIntl();
  const label = intl.formatMessage(messageDescriptor, messageDescriptorValues);
  return (
    <option {...props} label={label}>
      {label}
    </option>
  );
};

export const FormattedEmptyDefaultMessage = (props) => {
  const intl = useIntl();
  return _get(intl.messages, props.id) ? <FormattedMessage {...props} /> : null;
};

function makeInternational(Component) {
  const InternationalComponent = ({ intlProps, componentRef, ...props }) => {
    const intl = useIntl();
    const translatedProps = _reduce(
      intlProps,
      (acc, description, prop) => {
        acc[prop] = intl.formatMessage(
          description.descriptor,
          description.values
        );
        return acc;
      },
      {}
    );
    return <Component {...translatedProps} ref={componentRef} {...props} />;
  };
  const componentName =
    typeof Component === 'string' ? Component : Component.displayName;
  InternationalComponent.displayName = `InternationalComponent(${componentName})`;
  return InternationalComponent;
}

export { makeInternational };
